// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin: 0;
}
.grid.payments {
  grid-template-columns: repeat(6, auto);
}
i {
  padding-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/payments/payment-method-list/payment-method-list.component.less"],"names":[],"mappings":"AAEA;EACI,SAAA;AADJ;AAGA;EACI,sCAAA;AADJ;AAIA;EACI,mBAAA;AAFJ","sourcesContent":["@import (reference) url(\"../../../../styles.less\");\n\nh1 {\n    margin: 0;\n}\n.grid.payments {\n    grid-template-columns: repeat(6, auto);\n}\n\ni {\n    padding-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
